import { render, staticRenderFns } from "./DisplayTag.vue?vue&type=template&id=1198260e&scoped=true"
import script from "./DisplayTag.vue?vue&type=script&lang=js"
export * from "./DisplayTag.vue?vue&type=script&lang=js"
import style0 from "./DisplayTag.vue?vue&type=style&index=0&id=1198260e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1198260e",
  null
  
)

export default component.exports